// Button component
import React from 'react';
import classNames from 'classnames';

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  loading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  loading = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        'px-16 py-8 bg-black text-white rounded-[6px] transition-default hover:bg-neutral-800 disabled:bg-neutral-400 disabled:text-disabled-text',
        { 'loading-overlay': loading },
        className,
      )}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export const OutlineButton: React.FC<ButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  loading = false,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        'px-16 py-8 bg-[#F9F9F9] text-[#1D1D1E] border border-[#E4E4E7] rounded-[6px] transition-default hover:bg-[#e1e1e1a3] disabled:bg-neutral-400 disabled:text-disabled-text',
        { 'loading-overlay': loading },
        className,
      )}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

interface GradientButtonProps extends ButtonProps {
  gradientFrom?: string;
  gradientTo?: string;
}

export const GradientButton: React.FC<GradientButtonProps> = ({
  children,
  onClick,
  className = '',
  disabled = false,
  type = 'button',
  gradientFrom = '#6A0DAD',
  gradientTo = '#FF69B4',
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={classNames(
        'px-16 py-8 text-white rounded-10 transition-default',
        'bg-gradient-to-r hover:opacity-80 disabled:opacity-50 disabled:cursor-not-allowed',
        'shadow',
        className,
      )}
      style={{
        backgroundImage: `linear-gradient(to right, ${gradientFrom}, ${gradientTo})`,
      }}
      disabled={disabled}
    >
      {children}
    </button>
  );
};
